import { request } from "../../core";

/**
 * 获取菜单列表
 * @param {object} data
 * @returns
 */
export function getMenuList(data) {
  return request.post({
    url: "/api/ums/sysResource/getMenuList",
    data,
  });
};

